import { ComponentHOC } from "components/ComponentHOC/ComponentHOC";
import React, { useEffect, useRef } from "react";
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import { Route, Routes } from "react-router-dom";
import { BaseRouteProps, FoundRouteType, KeyValueObject } from "types/types";
import { ENDPOINTS } from "./endpoints";
import { http } from "./http";
import { getEnv } from "config/runtimeEnv";
import { DynamicFormsPage } from "pages/OfficeAutomation/FormBuilder/components/DynamicFormsPage/DynamicFormsPage";

// export function submitForm(event): boolean { // بررسی می کند که آیا فیلد های ریکوایرد خالی هستند یا خیر
//   event.preventDefault()
//   let result = true;
//   let requiredInputs = document.querySelectorAll(".required-input");
//   if (requiredInputs.length !== 0) {
//     requiredInputs.forEach((requiredInput) => {
//
//       if ((requiredInput as HTMLInputElement).value.length == 0) {
//         (requiredInput.nextSibling?.firstChild as HTMLElement).style.display = "inline-block";
//         result = false;
//       } else {
//         (requiredInput.nextSibling?.firstChild as HTMLElement).style.display = "none";
//       }
//     })
//   }
//   return result;
// }
export function urlParams() {
  const urlParams = new URLSearchParams(window.location.search);
  const result: { [key: string]: string } = {};
  for (let i of Array.from(urlParams.keys()))
    result[i] = urlParams.get(i) || "";

  return result;
}
/* string wordWithoutLanguage = word.Remove(word.Length - 2, 2);
string wordLanguage = word.Substring(word.Length - 2, 2);
if (wordLanguage == "EN")
    return resourceSet.GetString(wordWithoutLanguage) + resourceSet.GetString("EN");
else
    return resourceSet.GetString(word);
 */
export function trans(
  key: string,
  params?: string | (KeyValueObject | (string | number | boolean)[]),
  defaultValue?: string
) {
  let lang: any = localStorage.getItem("DefaultLanguage");
  let data: any = localStorage.getItem(lang);
  const paramList = params && typeof params != "string" ? params : {};
  const defaultV = defaultValue || (typeof params == "string" ? params : key);
  if(typeof key =="object") return key
  let val = defaultValue;
  if (data && key) {
    data = JSON.parse(data);
    if (key.slice(-2) == "EN" && key.length > 2) {
      key = key.replace("EN", "");
      if (data[key.toLowerCase()]) {
        val = data[key.toLowerCase()] + " " + trans("EN");
      } else {
        val =
          data[key.toLowerCase().replace("form", "")] + " " + trans("EN") ||
          defaultV + " " + trans("EN");
      }
    } else {
      if (data[key.toLowerCase()]) {
        val = data[key.toLowerCase()];
      } else {
        val = data[key.toLowerCase().replace("form", "")] || defaultV;
      }
    }
  }
  for (let i in paramList) {
    val = val?.replace(`{${i}}`, paramList[i]);
  }

  if (val == undefined) {
    return key as string;
  } else {
    return val as string;
  }
}
(window as any).t = trans;

export function changeDateFormat(date) {
  let newDate = date.split("T")[0].replaceAll("-", "/");
  return (
    newDate +
    " " +
    date.split("T")[1].split(":")[0] +
    ":" +
    date.split("T")[1].split(":")[1]
  );
}


export const convertToISO = (dateString) => {
  // Ensure the input format is YYYY/MM/DD
  if(!dateString.includes("T")){
    const [datePart, timePart] = dateString.split(" ");
    const dateParts = datePart.split("/");
    if (dateParts.length !== 3) return "Invalid Date Format";
  
    const [year, month, day] = dateParts.map(Number);
    if (!year || !month || !day) return "Invalid Date";
  
    let hours = 0, minutes = 0;
    if (timePart) {
      const timeParts = timePart.split(":");
      if (timeParts.length === 2) {
        [hours, minutes] = timeParts.map(Number);
      }
    }
  
    // Create a Date object in local time
    const date = new Date(year, month - 1, day, hours, minutes);
  
    // Convert to ISO string in UTC
    return date.toISOString();
  }else{
    return dateString

  }
};



export function cleanObject(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}

export function findRoutesTitle(
  targetRoutes,
  wantedRoute: string
): FoundRouteType {
  let foundRoute: FoundRouteType = {
    foundRouteTitle: "",
    hasComponent: false,
  };

  Object.keys(targetRoutes).every((item) => {
    if (targetRoutes[item].route === wantedRoute) {
      foundRoute.foundRouteTitle = targetRoutes[item].title;
      if (targetRoutes[item].component !== undefined) {
        foundRoute.hasComponent = true;
      }
      return false;
    } else if (
      foundRoute.foundRouteTitle === "" &&
      targetRoutes[item].routes !== undefined
    ) {
      foundRoute = findRoutesTitle(targetRoutes[item].routes, wantedRoute);
    }
    return true;
  });

  return foundRoute;
}

export const renderRoutes = (routeList: BaseRouteProps, PositionId ,LOCATION) => {
  const routes = (routeList || {}) as any;

  return (
    <Routes>
      {Object.keys(routes).map((app: any,indexApp) =>
        routes[app].routes ? (
          <Route key={routes[app].route} path={routes[app].route}>
            routes[k]?.routes ?(
            {Object.keys(routes[app].routes).map((j: any, index) => (
              <Route
                key={routes[app].routes[j].route}
                path={routes[app].routes[j].route}
                element={<ComponentHOC {...routes[app].routes[j]} />}
              />
            ))}
            :
            <Route
              key={routes[app].route}
              path={routes[app].route}
              element={<ComponentHOC {...routes[app]} />}
            />
            )
          </Route>
        ) : (
          <React.Fragment  key={indexApp}>
            {routes[app] &&
              Object.keys(routes[app]).map((k: any) =>
                routes[app]?.[k]?.routes ? (
                  <Route
                    key={routes[app]?.[k]?.route}
                    path={routes[app]?.[k]?.route}
                  >
                    routes[app]?.[k]?.routes ?(
                    {Object.keys(routes[app]?.[k]?.routes).map(
                      (j: any, index) => (
                        <Route
                          key={routes[app]?.[k]?.routes[j].route}
                          path={routes[app]?.[k]?.routes[j].route}
                          element={
                            <ComponentHOC {...routes[app]?.[k]?.routes[j]} />
                          }
                        />
                      )
                    )}
                    :
                    <Route
                      key={routes[app]?.[k]?.route}
                      path={routes[app]?.[k]?.route}
                      element={<ComponentHOC {...routes[app]?.[k]} />}
                    />
                    )
                  </Route>
                ) : (
                  <React.Fragment key={routes[app]?.[k]?.route}>
                    <Route
                      key={routes[app]?.[k]?.route}
                      path={routes[app]?.[k]?.route}
                      element={<ComponentHOC {...routes[app]?.[k]} />}
                    />
                  </React.Fragment>
                )
              )}
          </React.Fragment>
        )
      )}
      {LOCATION.pathname.includes("Dynamic")&&
      <Route path="*" element={<DynamicFormsPage  />} />
      }
    </Routes>
  );
};

export function findValueByKey(object: Object, objKey: string) {
  let value: string = "";
  Object.keys(object).forEach((key) => {
    if (key === objKey) {
      value = object[key];
    }
  });
  return value;
}

export const useOutsideClick = (callback) => {
  const ref = useRef<any>();

  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref]);

  return ref;
};

export const useInsideClick = (callback) => {
  const ref = useRef<any>();

  useEffect(() => {
    const handleClick = (event) => {
      if (ref.current && ref.current.contains(event.target)) {
        callback();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref]);

  return ref;
};

export const isInViewport = function (element: HTMLElement): boolean {
  const distance = element.getBoundingClientRect();

  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
};


export function ConvertFormatISOToYYYYMMD(dateISOString) {
  const date = new Date(dateISOString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // اضافه کردن صفر
  const day = String(date.getDate()).padStart(2, '0');       // اضافه کردن صفر

  return `${year}/${month}/${day}`;
}

export function dateConverter(
  year: number,
  month: number,
  day: number
): number[] {
  //تبدیل تاریخ میلادی به شمسی
  var g_d_m, jy, jm, jd, gy2, days;
  g_d_m = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
  gy2 = month > 2 ? year + 1 : year;
  days =
    355666 +
    365 * year +
    ~~((gy2 + 3) / 4) -
    ~~((gy2 + 99) / 100) +
    ~~((gy2 + 399) / 400) +
    day +
    g_d_m[month - 1];
  jy = -1595 + 33 * ~~(days / 12053);
  days %= 12053;
  jy += 4 * ~~(days / 1461);
  days %= 1461;
  if (days > 365) {
    jy += ~~((days - 1) / 365);
    days = (days - 1) % 365;
  }
  if (days < 186) {
    jm = 1 + ~~(days / 31);
    jd = 1 + (days % 31);
  } else {
    jm = 7 + ~~((days - 186) / 30);
    jd = 1 + ((days - 186) % 30);
  }
  return [jy, jm, jd];
}

export function getPageSize(name, newSize?) {
  //گرفتن پیج سایز از لوکال استوریج

  let sizePage;
  let hedTables = localStorage.getItem("DataGridSetting");
  let locallist;
  let flag = true;
  if (hedTables == null) {
    locallist = [];
  } else {
    locallist = JSON.parse(hedTables);
  }
  locallist.forEach((item) => {
    if (item[0] == name) {
      sizePage = item[3];
      flag = false;
      if (newSize) {
        sizePage = newSize;
        item[3] = newSize;
      }
      if (sizePage) {
      } else {
        sizePage = newSize ? newSize : 10;
      }
    }
  });
  if (flag) {
    sizePage = 10;
    locallist.push([name, [], [], 10, [], ""]);
  }
  localStorage.setItem("DataGridSetting", JSON.stringify(locallist));

  return sizePage;
}
export function getGridSetting(name) {
  //گرفتن پیج سایز از لوکال استوریج

  let settings;
  let hedTables = localStorage.getItem("DataGridSetting");
  let locallist;
  let flag = true;
  if (hedTables == null) {
    locallist = [];
  } else {
    locallist = JSON.parse(hedTables);
  }
  locallist.forEach((item) => {
    if (item[0] == name) {
      settings = [item[4] ? item[4] : "", item[5] ? item[5] : []];

      flag = false;
    }
  });
  if (flag) {
    settings = ["", []];
  }

  return settings;
}

export function formatMinutes(minutes) {
  return minutes < 10 ? `0${minutes}` : minutes;
}

export function formatSeconds(seconds) {
  return seconds < 10 ? `0${seconds}` : seconds;
}

export function uuidv4() {
  return "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function convertToCSV(objArray) {
  var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  var str = "";

  for (var i = 0; i < array.length; i++) {
    var line = "";
    for (var index in array[i]) {
      if (line != "") line += ",";

      line += array[i][index];
    }

    str += line + "\r\n";
  }
  return str;
}

function exportCSVFile(headers, items, fileTitle) {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  let jsonObject = JSON.stringify(items);

  let csv: any = "\ufeff";
  csv += convertToCSV(jsonObject);
  let exportedFilenmae = fileTitle + ".csv" || "export.csv";

  let blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), csv], {
    type: "text/csv;charset=utf-8;",
  });

  if (navigator.msSaveOrOpenBlob) {
    // IE 10+
    navigator.msSaveOrOpenBlob(blob, exportedFilenmae);
  } else {
    let link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      let url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilenmae);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

export function downloadCSV(data = [], startindex, fileName) {
  let headers = {};
  if (data?.length > 0) {
    Object.keys(data[0]).map((item, index) => {
      if (index >= startindex) {
        headers[item] = trans(item);
      }
    });
    let itemsFormatted: any = [];
    data.forEach((item) => {
      let obj = {};
      Object.keys(headers).map((hed) => {
        obj[hed] =
          `${item[hed]}`.length > 0
            ? `${item[hed]}`.replaceAll(",", " ").replaceAll(/[\r\n]/gm, " ")
            : " ";
      });
      itemsFormatted.push(obj);
    });
    exportCSVFile(headers, itemsFormatted, fileName);
  } else {
  }
}

export const postDataForPrint = (repData, type) =>
  http({
    baseURL: `${getEnv("REACT_APP_REPORTING_SERVICE_URL")}`,
    url: ENDPOINTS.reportST[type == 1 ? "viewer" : "designer"].saveData,
    method: "post",
    data: repData,
  })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return Promise.reject(err);
    });

export async function GetReportWithJsonData(id, repData=null, type) {
let url= `${
  `${getEnv("REACT_APP_REPORTING_SERVICE_URL")}`+
  ENDPOINTS.reportST[type == 1 ? "viewer" : "designer"].getReport
}/${id}`

  if(repData){
    let _objData: any = new FormData();
    _objData.append("repData", JSON.stringify(repData));
    const res = await postDataForPrint(_objData, type);
    window.open(url+`?dataId=${res}&userDataId=${sessionStorage.getItem("accept-data")}`,
      "_blank"
    );
  }else{
    window.open(url,
      "_blank"
    );
  }

}
export async function addItemToBasket(item, id) {
  let Basket: any = localStorage.getItem("Basket");
  if (Basket) {
    Basket = JSON.parse(Basket);
    if (+item.order[id].count == 0) {
      if (Basket[item.Id]) {
        delete Basket?.[item.Id].order[id];
        if (Object.values(Basket?.[item.Id].order).length == 0) {
          delete Basket?.[item.Id];
        }
      }
    } else {
      if (Basket[item.Id] != undefined) {
        Basket[item.Id].order = {
          ...Basket[item.Id].order,
          [id]: item.order[id],
        };
      } else {
        Basket = {
          ...Basket,
          [item.Id]: item,
        };
      }
    }
  } else {
    Basket = {
      [item.Id]: item,
    };
  }
  localStorage.setItem("Basket", JSON.stringify(Basket));
}

export function getBasketData() {
  let Basket: any = localStorage.getItem("Basket");
  if (Basket) {
    Basket = Object.values(JSON.parse(Basket));
  } else {
    Basket = [];
  }
  return Basket;
}

function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}

export function GroupingPriceFunction(price) {
  if (price === undefined || price === null) return "";

  const cleaned = price.toString().replace(/,/g, '');
  if (isNaN(cleaned)) return price.toString();

  // جداسازی بخش عدد صحیح و اعشاری
  const [integerPart, decimalPart] = cleaned.split('.');

  const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // بازگرداندن بخش گروه‌بندی‌شده همراه با اعشار اگر وجود داشته باشد
  return decimalPart !== undefined ? `${groupedInteger}.${decimalPart}` : groupedInteger;
}

/* export function GroupingPriceFunction(price) {
  if(price!=undefined){
    price=price.toString()
  
  if ( price!=undefined&& (isNumber(price) || isNumber(+price)|| isNumber(+(price.replaceAll(",", ""))))) {
    if (price && price.length > 0) {
      price = price.replaceAll(",", "");
    }
    return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  } else {
    return price+"";
  }
}
} */

export function padWithZeros(num, str) {
  if (str == "null") {
    return "";
  } else {
    let difference = num - str.length;
    if (difference > 0) {
      return "0".repeat(difference) + str;
    }
    return str;
  }
}

/* export function padWithZeros(length, str) {
  str = str.toString();

  return str.padStart(length, '0');
}

 */

/* export function roundOrTruncate(number, RoundingPlace, floor:boolean) {
  try {

    

    if (number) {
      if (floor) {
        const factor = Math.pow(10, RoundingPlace);
        return Math.floor(+number * factor) / factor;
      } else {
        const prec = Math.pow(10, Math.abs(RoundingPlace) );
        if(RoundingPlace>=0){
          return Math.round(number / prec) * prec;
        }else{
          return Math.round(number * prec) / prec;
        }
      }
    } else {
      return number;
    }
  } catch (error) {
    return 0
  }
}
 */





/// <summary>
/// گرد کردن عدد مورد نظر<br/>
/// مثال<br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> = -1 -> 11.20 <br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> =  0 -> 11.00 <br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> =  1 -> 10.00 <br/>
/// </summary>
export function RoundWithRoundingPlace(value: number, roundingPlace: number = 0): number {
  if (value === 0) {
      return 0;
  }
  const prec = Math.pow(10, Math.abs(roundingPlace) );
  if(roundingPlace>=0){
    return Math.round(value / prec) * prec;
  }else{
    return Math.round(value * prec) / prec;
  }
}

export function RoundWithExcelMethod(value, decimals = 2) {
  const factor = Math.pow(10, decimals);

  if (value >= 0) {
    return Math.round(value * factor) / factor;
  } else {
    return -Math.round(Math.abs(value) * factor) / factor;
  }
}

/// <summary>
///گ عدد مورد نظر<br/>
/// مثال<br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> = -1 -> 11.20 <br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> =  0 -> 11.00 <br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> =  1 -> 10.00 <br/>
/// </summary>
export function FloorWithRoundingPlace(value: number, roundingPlace: number = 0): number {
  if (value === 0) {
      return 0;
  }
  const prec = Math.pow(10, Math.abs(roundingPlace) );
  if(roundingPlace>=0){
    return Math.floor(value / prec) * prec;
  }else{
    return Math.floor(value * prec) / prec;
  }
}
/// <summary>
/// گرد کردن عدد مورد نظر<br/>
/// مثال<br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> = -1 -> 11.20 <br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> =  0 -> 11.00 <br/>
/// <paramref name="value"/> = 11.16 -> <paramref name="roundingPlace"/> =  1 -> 10.00 <br/>
/// </summary>
export function CeilWithRoundingPlace(value: number, roundingPlace: number = 0): number {
  if (value === 0) {
      return 0;
  }
  const prec = Math.pow(10, Math.abs(roundingPlace) );
  if(roundingPlace>=0){
    return Math.ceil(value / prec) * prec;
  }else{
    return Math.ceil(value * prec) / prec;
  }
}


  






export function convertAddress(obj) {
  let str = "";
  try {
    const converData = JSON.parse(obj);
    Object.keys(converData).forEach((item, index) => {
      if (
        converData[item] &&
        item !== "extradescription" &&
        item !== "description"
      ) {
        str += `${trans(item)} : ${converData[item]}  `;
      }
      return str;
    });
  } catch (error) {
    str = obj;
  }

  return str;
}


const sqlInjectionPattern = `^[^<>']*$`;
const numberPattern=/^[0-9,\.]*$/

export const validateInput = (input) => {
  if ( new RegExp(sqlInjectionPattern).test(input)) {
    return true; 
  }
  return false;
};

export const validateInputAsNumber= (input) => {
  if ( new RegExp(numberPattern).test(input)) {
    return true; 
  }
  return false;
};
export const RoundOutputOperation = (number) => {
 return RoundWithRoundingPlace(number,-2)
};

export const  textChange = (title) => {
if(/\d+(\.\d+)?/g.test(title)){
  var regex = /[\u0600-\u06FF]+/;
  var numRegex = /\d+/g;

  let text = "";
  title.split(" ").forEach((item: any, index) => {
    if (regex.test(item as any)) {
      text += item + " ";
    } else {
      text +=
        " " +
        '<div style="direction: ltr;unicodeBidi:unset;display:inline">' +
        item +
        "</div>" +
        " ";
    }
  });
  title = text;
  return title.replaceAll(/\d+/g, (i) => {
    return `<div style="direction: ltr;unicodeBidi:unset;display:inline">  ${i} </div>`;
  });
}
else{
  return title
}


  
};




export function updateRemovedColInGrid(parentName ,remove ,removedColumns , setRemovedColumns ){

 let hedTables = localStorage.getItem("DataGridSetting");
 let locallist;
 if (hedTables == null) {
   locallist = [];
 } else {
   locallist = JSON.parse(hedTables);
 }
 locallist.forEach((item) => {
   if (item[0] === parentName) {
     item[6] = [...removedColumns, ...remove];
   }
 });
 setRemovedColumns([...removedColumns, ...remove]);

 localStorage.setItem(
   "DataGridSetting",
   JSON.stringify(locallist)
 );
}

export const disabledFieldCheckValidity=(target)=>{
  if((target.value=='' || !target.value)  ){
    target.disabled=false
    target.reportValidity('')
    target.disabled=true
     return true
  }
}


 export const showTwoFloatNumber=(value)=>{
      if(value?.toString()?.split('.')?.[1] &&value?.toString()?.split('.')?.[1]?.length>2)
        {return value?.toString()?.split('.')?.[0]+'.'+value?.toString()?.split('.')?.[1]?.slice(0,2)}else
        { return  value}
                                          

    }

//convert "1404/03/02 10:20 or 1404/03/02" to Tue Aug 19 2025 15:41:00 GMT+0330 (Iran Standard Time)
    export const ConvertiSolarDateToGregorianDate=(date)=>{
const shamsiStr =date;

const splitPart= shamsiStr?.includes(" ")?shamsiStr.split(" "):[shamsiStr];
const [year, month, day] = splitPart[0].split("/").map(Number);
let hour=0
let minute=0
if(splitPart?.[1]){
hour = splitPart[1].split(":").map(Number)[0]
minute = splitPart[1].split(":").map(Number)[1]
}
const dateObject = new DateObject({
  calendar: persian,   
  year,
  month,
  day,
  hour,
  minute,
});

const jsDate = dateObject.toDate(); 

return jsDate

    }